/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.23.0
 * @since 1.23.0
 */

import {
    IActionConflictItem,
    IProductOfferingsSubscriberActivationItem,
} from '../../WizardProductOfferings/wizardProductOfferingsTypes';
import { isCollectiveProductCustomConflict } from './isCollectiveProductCustomConflict';

export const getItemsWithCustomCollectiveProductConflicts = (
    items: IProductOfferingsSubscriberActivationItem[],
): IProductOfferingsSubscriberActivationItem[] =>
    items.filter((item) => {
        const { actionConflicts } = item;
        if (actionConflicts) {
            return Object.values(actionConflicts).some((elements) =>
                elements.some((conflict: IActionConflictItem) => isCollectiveProductCustomConflict(conflict)),
            );
        }
        return false;
    });
